<template>
    <b-container fluid class="headerPushDown">
        <b-container class=" ml-auto mr-auto">
            <p class="mt-5 text-center text-uppercase" v-html="ConfimationMessage"></p>
        <b-row>
            <b-col cols="0" md="3">

            </b-col>
            <b-col cols="12" md="6">
                <div v-if="ConfirmationSuccess">
                    <h4 class="text-center">Vielen Dank!</h4>
                        <p class="text-center">
                            Hervorragend - der Registrierungsvorgang wurde erfolgreich abgeschlossen.

                            <br><br>Bis bald ganz oben!
                            <br>Das Kahlenberg-Team
                        </p>
                        <b-button  to="/app/login" class="mt-2 text-uppercase" size="md" variant="light" style="float: right;">
                                Login
                        </b-button>
                </div>
            </b-col>
        </b-row>


        </b-container>
  </b-container>
</template>


<script>

export default {
    name:'ShopConfirmEmailView',
    components: {

    },
    data() {
        return {
            customerId: undefined,
            deepLinkId: undefined,
            ConfimationMessage:'',
            ConfirmationSuccess: false,
        }
    },
    computed: {
        getSelectedLanguage() {
            return this.$store.getters.getLanguage;
        },
        getLanguageItem: function() {
            return this.$store.getters.getLanguageStrings;
        },
    },
    methods:{
        async postConfirmEmailToServer(params) {

        let config = this.$store.getters.getRestHeaderConfig;
        config.params = undefined; // make sure they are empty

        console.log('POST confirmEmail:', params, config);

        await this.$http
            .post(this.$store.getters.getRestServerBaseUrl + "/confirmRegister", params , config)
            .then(response => {
               // console.log("POST confirmEmail response: "  + response.status, response);

                response.data = '';
                this.ConfimationMessage = 'E-Mail Adresse bestätigt'
                this.ConfirmationSuccess=true;

            })
            .catch(err => {
                console.log("POST confirmEmail ERROR: ", err.response);
                this.ConfimationMessage = 'Bei der Validierung Deiner E-Mail Adresse ist ein Fehler aufgetreten.'
               this.ConfirmationSuccess=false;
            });
        },
    },
    beforeMount(){

    },
    mounted(){
        this.deepLinkId = this.$router.history.current.query.deepLinkId;
        this.customerId = this.$router.history.current.query.customerId;
        //console.log('Query:', this.deepLinkId,this.customerId);

        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

        if(this.deepLinkId && this.customerId){
           // console.log('Sending Confirmation...');
            this.ConfimationMessage ='Verifizierung...';

           this.postConfirmEmailToServer({customerId: this.customerId , deepLinkId: this.deepLinkId});
        }else{
           // console.log('no deeplink/CustomerId');

            this.$router.push('/app/login');
        }


    }
}
</script>
